import Parse from "parse";

type Language = Parse.Object;
type OD3_Tenant = Parse.Object;

export interface GlossaryEntryAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  title: string;
  text?: string;
  keyword: string;
  markdown?: string;
  tenant: OD3_Tenant;
  tags?: any[];
  language: Language;
}

export class GlossaryEntry extends Parse.Object<GlossaryEntryAttributes> {
  constructor(data?: Partial<GlossaryEntryAttributes>) {
    super("APP_GlossaryEntry", data as GlossaryEntryAttributes);
  }
}

Parse.Object.registerSubclass("APP_GlossaryEntry", GlossaryEntry);
